'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GenericForm = require('./components/GenericForm.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GenericForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-messages/lib/components/generic-form/index.js
// module id = 1492
// module chunks = 1